<template>
  <div></div>
</template>

<script>
export default {
  name: 'build-logs',
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
